export const LINKEDINAUTHENTICATIONREQUEST = "LINKEDINAUTHENTICATIONREQUEST"
export const LINKEDINAUTHENTICATIONFAILURE = "LINKEDINAUTHENTICATIONFAILURE"
export const LINKEDINAUTHENTICATIONSUCCESS = "LINKEDINAUTHENTICATIONSUCCESS"


export const LINKEDINCLIENTID = "78rrxawa76wgv4"
export const LINKEDINCLIENTSECRET = "A2w3eq1WXymUVy8G"
export const LINKEDIN_REDIRECTURL_LOGIN = process.env.REACT_APP_UI + "login"
export const LINKEDIN_REDIRECTURL_REGISTER = process.env.REACT_APP_UI + "register"
export const scope = "email openid"